import type { TCargoType } from 'api/swagger';

export interface ICargoMainProps {
  cargoId: number;
  cargoType: TCargoType;
}

export enum ECargoMainTab {
  items = 'cargos',
  documents = 'documents',
  trips = 'trips',
}
